import { render, staticRenderFns } from "./DeclaracionInicioInves.vue?vue&type=template&id=7cdba404"
import script from "./DeclaracionInicioInves.vue?vue&type=script&lang=ts"
export * from "./DeclaracionInicioInves.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports